import Vue from 'vue';
import debounce from 'lodash/debounce';
import includes from 'lodash/includes';
import capitalize from 'lodash/capitalize';

Vue.use(debounce);
Vue.use(includes);
Vue.use(capitalize);
